.body {
	flex: 1 1 0%;
	display: flex;
	flex-direction: column;
	overflow: auto;
	gap: var(--size-8);
}

.settings {
	display: flex;
	flex-direction: column;
	gap: var(--size-5);
}

.card {
	display: flex;
	flex-direction: column;
	gap: var(--size-5);
	padding: var(--size-5);
}

.providerHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.providerName {
	font-weight: 600;
	font-size: var(--text-subtitle-2);
}

.settingRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.settingInfo {
	display: flex;
	flex-direction: column;
	gap: var(--size-1);
}

.settingActions {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}

.settingLabel {
	font-weight: 600;
}

.settingDescription {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.list {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
}

.listItem {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--size-4);
}

.listItemActions {
	display: flex;
	align-items: center;
	gap: var(--size-3);
	flex-shrink: 0;
}

.listItemName {
	font-weight: 500;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.statusChip {
	text-transform: capitalize;
	display: inline-flex;
	align-items: center;
	flex-shrink: 0;
	padding: var(--size-1) var(--size-3);
	border-radius: var(--radius-sm);
	font-size: var(--text-caption);
	font-weight: 500;

	&[data-state="verified"],
	&[data-state="default"],
	&[data-state="active"],
	&[data-state="on"] {
		color: var(--color-success-foreground);
		background-color: var(--color-success-background);
	}

	&[data-state="pending"],
	&[data-state="expiring"] {
		color: var(--color-warning-foreground);
		background-color: var(--color-warning-background);
	}

	&[data-state="expiring"] {
		text-transform: none;
	}

	&[data-state="failed"],
	&[data-state="expired"] {
		color: var(--color-error-foreground);
		background-color: var(--color-error-background);
	}

	&[data-state="off"] {
		color: var(--color-text-subtle);
		background-color: var(--color-surface-elevated);
	}
}

.listItemInfo {
	display: flex;
	flex-direction: column;
	gap: var(--size-1);
	min-width: 0;
}

.listItemMeta {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: var(--size-1) var(--size-2);
	font-size: var(--text-caption);
	color: var(--color-text-subtle);

	& > * + *::before {
		content: "·";
		margin-right: var(--size-2);
	}
}

.keyHint {
	font-family: var(--font-mono);
}

.empty {
	margin: 0;
	color: var(--color-text-subtle);
	font-size: var(--text-body);
}
